// extracted by extract-css-chunks-webpack-plugin
module.exports = {"vote":"vote-2cxwzXH9","voted":"voted-PrxXX3Fz"};